import React from "react";
import styled, { css } from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import HeaderSearchBar from "core/SearchBar/variations/HeaderSearchBar";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const SearchBarStyled = styled.div`
    position: absolute;
    z-index: 1;
    top: 0rem;

    ${({ $styleProps: { left, right } }) => {
        return css`
            transition: left ${left.speed}ms ease ${left.delay}ms,
                right ${right.speed}ms ease ${right.delay}ms;
            left: ${convertPxToRem(left.value)};
            right: ${convertPxToRem(right.value)};
        `;
    }}
`;

// Holds the Search Bar
export const SearchBar = () => {
    const {
        hasDedlayedSecondRow,
        isDarkMode,
        isCompact,
        animation: { styleProps }
    } = useSiteHeader();

    return (
        <SearchBarStyled $styleProps={styleProps}>
            <HeaderSearchBar
                id="header-search-tablet-desktop"
                isDarkMode={isDarkMode}
                isDisabled={hasDedlayedSecondRow && !isCompact}
            />
        </SearchBarStyled>
    );
};

export default SearchBar;
